module.exports = __webpack_public_path__ + "static/media/golf-ball.dd02f136.svg";